import { getDateUtil } from "./dateUtils";
export const DATE_RANGE_PRESETS = [
  { key: 'today', label: 'Today', value: { from: getDateUtil(0), to: getDateUtil(0) } },
  { key: 'last_2_days', label: 'Last 2 days', value: { from: getDateUtil(-2), to: getDateUtil() } },
  { key: 'last_7_days', label: 'Last 7 days', value: { from: getDateUtil(-7), to: getDateUtil() } },
  { key: 'this_week', label: 'This week', value: { from: getDateUtil(-(new Date().getDay() === 0 ? 6 : new Date().getDay() - 1)), to: getDateUtil() } },
  { key: 'this_month', label: 'This month', value: { from: new Date(new Date().getFullYear(), new Date().getMonth(), 1), to: getDateUtil() }},
  { key: 'custom', label: 'Custom range', value: { from: null, to: null } },
  { key: 'all_time', label: 'All time', value: { from: null, to: null } },
];

export const SMART_PUBLISHED_CREATED_AT_PRESETS = [
  { key: 'last_published_on', label: 'Since last publishing complete', value: { from: null, to: null } },
  { key: 'custom', label: 'Custom range', value: { from: null, to: null } },
  { key: 'all_time', label: 'All time', value: { from: null, to: null } },
];

export const SMART_PRESET_MAPPING = {
  date_ranges: DATE_RANGE_PRESETS,
  custom_smart_publish_presets : SMART_PUBLISHED_CREATED_AT_PRESETS,
};